import { useMemo } from 'react';
import * as MapGL from 'react-map-gl/mapbox';
import { useSnapshot } from 'valtio';
import { getColorFromRgb } from '../common';
import store from '../store';
import { isLine, isPoint, isPolygon, LINE_WIDTH, POINT_RADIUS } from './common';

const HOVERED_FEATURE_ID = 'hovered-feature-id';

export default function HoverLayer() {
  const { hoveredFeature, intelligenceFeatures } = useSnapshot(store) as typeof store;

  // biome-ignore lint/correctness/useExhaustiveDependencies: legacy
  const content = useMemo(() => {
    if (!hoveredFeature || !hoveredFeature.id?.toString()) {
      return null;
    }

    const featureId = hoveredFeature?.id?.toString();

    if (!featureId) return null;

    const item = intelligenceFeatures[featureId];
    const color = getColorFromRgb(item.rgb);

    if (isLine(hoveredFeature)) {
      return (
        <MapGL.Source key={`hovered-feature-source`} id={HOVERED_FEATURE_ID} type="geojson" data={hoveredFeature}>
          <MapGL.Layer
            source={HOVERED_FEATURE_ID}
            type="line"
            paint={{
              'line-color': color,
              'line-width': LINE_WIDTH * 4,
            }}
          />
        </MapGL.Source>
      );
    } else if (isPolygon(hoveredFeature)) {
      return (
        <MapGL.Source key={`hovered-feature-source`} id={HOVERED_FEATURE_ID} type="geojson" data={hoveredFeature}>
          <MapGL.Layer
            source={HOVERED_FEATURE_ID}
            type="fill"
            paint={{
              'fill-color': color,
              'fill-opacity': 0.75,
            }}
          />
          <MapGL.Layer
            source={HOVERED_FEATURE_ID}
            type="line"
            paint={{
              'line-color': color,
              'line-width': LINE_WIDTH * 2,
            }}
          />
        </MapGL.Source>
      );
    } else if (isPoint(hoveredFeature)) {
      return (
        <MapGL.Source key={`hovered-feature-source`} id={HOVERED_FEATURE_ID} type="geojson" data={hoveredFeature}>
          <MapGL.Layer
            source={HOVERED_FEATURE_ID}
            type="circle"
            paint={{
              'circle-stroke-color': color || 'red',
              'circle-stroke-width': LINE_WIDTH,
              'circle-color': color,
              'circle-opacity': 0.75,
              'circle-radius': POINT_RADIUS,
            }}
          />
        </MapGL.Source>
      );
    }

    return null;
  }, [hoveredFeature]);

  return <>{content}</>;
}
